var __jsx = React.createElement;
import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { getPricing } from '@spa/offer/utils/pricing';
import useScrollLock from '@spa/shared/hooks/useScrollLock';
import { formatDate, formatMoney, fromMoneyCoreFormat } from '@spa/shared/utils';
import Button from '@spa/shared/components/Unisystem/Button';
import { redirectToCheckout } from '@spa/shared/utils/redirect';
import Calendar from '@spa/shared/components/Unisystem/Calendar';
import { isRangeValid } from '@spa/shared/utils/availabilities/range-valid';
import { changeUrlQuery, normalizeQuery } from '@spa/shared/utils/queryParams';
import { trackFixedContractCancelClick, trackFixedContractConfirmClick, trackFixedContractModalOpen, trackFixedContractOptionClick, trackRequestIntention, trackRequestToBook, trackSelectDates, trackRequestToBookAmplitude } from '@spa/offer/store/actions/tracking';
import Notifications from '@spa/shared/components/Unisystem/Calendar/notifications';
import { Wrapper, Dates, Price, Content, LeftSection, MainWrapper } from './styles';
import { requestPriceDetails as _requestPriceDetails, setIsCalendarOpenAction, setPriceDetailsData, setPriceDetailsRequest as _setPriceDetailsRequest } from '@spa/offer/store/actions/offer';
import { showModalAction } from '@spa/shared/store/actions/modal';
import { modalIds } from '@spa/offer/components/Modals/modal-displayer';
import { isDoubleBooking } from '@spa/offer/utils/doubleBookings';
import { getAvailableFrom } from '@spa/shared/utils/transformers/contracts';
import { getCountryNamefromCityCode } from '@spa/shared/utils/countryCode';
var DATE_FORMAT = 'dd MMM yyyy';
var HEADER_SIZE = 64;
var PricingBoxMobile = function PricingBoxMobile(_ref) {
  var _contract$fixed, _contract$fixed_unita;
  var accommodationOffer = _ref.accommodationOffer,
    paidBookings = _ref.paidBookings,
    priceDetailsRequest = _ref.priceDetailsRequest,
    priceDetailsData = _ref.priceDetailsData,
    hasPriceDetails = _ref.hasPriceDetails,
    setPriceDetailsRequest = _ref.setPriceDetailsRequest,
    requestPriceDetails = _ref.requestPriceDetails,
    isLoading = _ref.isLoading,
    isCalendarOpen = _ref.isCalendarOpen,
    setIsCalendarOpen = _ref.setIsCalendarOpen,
    showDoubleBookingModal = _ref.showDoubleBookingModal,
    trackSelectDatesAction = _ref.trackSelectDatesAction,
    trackRequestToBookAction = _ref.trackRequestToBookAction,
    trackRequestIntentionAction = _ref.trackRequestIntentionAction,
    trackFixedContractModalOpenAction = _ref.trackFixedContractModalOpenAction,
    trackFixedContractOptionClickAction = _ref.trackFixedContractOptionClickAction,
    trackFixedContractConfirmClickAction = _ref.trackFixedContractConfirmClickAction,
    trackFixedContractCancelClickAction = _ref.trackFixedContractCancelClickAction,
    property = _ref.property,
    trackRequestToBookAmplitudeAction = _ref.trackRequestToBookAmplitudeAction;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    language = _useTranslation.i18n.language;
  var router = useRouter();
  var _useState = useState(false),
    showPaymentSummary = _useState[0],
    setShowPaymentSummary = _useState[1];
  var _useScrollLock = useScrollLock(),
    lockScroll = _useScrollLock.lockScroll,
    unlockScroll = _useScrollLock.unlockScroll;
  var openCalendar = function openCalendar() {
    if (isAnyTypeFixed) {
      trackFixedContractModalOpenAction(offerId);
    }
    trackSelectDatesAction();
    trackRequestIntentionAction();
    setIsCalendarOpen(true);
  };
  var openPaymentDetails = function openPaymentDetails() {
    setShowPaymentSummary(true);
    setIsCalendarOpen(true);
  };
  var closeCalendar = function closeCalendar() {
    var _ref2, _router$query$moveIn, _ref3, _router$query$moveOut, _router$query$optionI;
    if (isAnyTypeFixed) {
      trackFixedContractCancelClickAction(offerId);
    }
    setPriceDetailsRequest({
      moveIn: (_ref2 = (_router$query$moveIn = router.query.moveIn) !== null && _router$query$moveIn !== void 0 ? _router$query$moveIn : router.query['move-in']) !== null && _ref2 !== void 0 ? _ref2 : null,
      moveOut: (_ref3 = (_router$query$moveOut = router.query.moveOut) !== null && _router$query$moveOut !== void 0 ? _router$query$moveOut : router.query['move-out']) !== null && _ref3 !== void 0 ? _ref3 : null,
      guests: +router.query.guests ? +router.query.guests : 1,
      optionId: (_router$query$optionI = router.query.optionId) !== null && _router$query$optionI !== void 0 ? _router$query$optionI : null
    });
    setIsCalendarOpen(false);
  };
  var offerId = accommodationOffer.id,
    contract = accommodationOffer.contract,
    offerGenderRestriction = accommodationOffer.restrictions.gender;
  var moveInRequest = priceDetailsRequest.moveIn,
    moveOutRequest = priceDetailsRequest.moveOut,
    guests = priceDetailsRequest.guests,
    optionId = priceDetailsRequest.optionId;
  var _ref4 = (priceDetailsData === null || priceDetailsData === void 0 ? void 0 : priceDetailsData.start_end) || {},
    moveIn = _ref4.start,
    moveOut = _ref4.end;
  var moveInDate = moveInRequest || moveIn ? new Date(moveInRequest || moveIn) : null;
  var moveOutDate = moveOut || moveOutRequest ? new Date(moveOutRequest || moveOut) : null;
  var formattedMoveIn = moveInDate ? formatDate(moveInDate, language, DATE_FORMAT) : t('Select dates');
  var formattedMoveOut = moveOutDate ? formatDate(moveOutDate, language, DATE_FORMAT) : t('Select dates');
  var _getPricing = getPricing({
      accommodationOffer: accommodationOffer,
      priceDetailsRequest: priceDetailsRequest,
      priceDetailsData: priceDetailsData
    }),
    isAnyTypeFixed = _getPricing.isAnyTypeFixed,
    extraPriceAmount = _getPricing.extraPriceAmount,
    firstRentValue = _getPricing.firstRentValue,
    referencePrice = _getPricing.referencePrice;
  var extraPrice = extraPriceAmount ? {
    amount: extraPriceAmount,
    currency_code: referencePrice.currency_code
  } : null;
  var isInstantBooking = contract.is_instant_booking;
  var setMoveInOut = function setMoveInOut(moveIn, moveOut) {
    return setPriceDetailsRequest({
      moveIn: moveIn,
      moveOut: moveOut
    });
  };
  var selectFixedOption = useCallback(function (optionId) {
    trackFixedContractOptionClickAction(offerId);
    setPriceDetailsRequest({
      optionId: optionId
    });
  });
  var propertyType = property.typology.type_code,
    offerType = property.lifecycle.rent_by,
    cityCode = property.location.address.city_code,
    propertyGenderRestriction = property.restrictions.gender;
  var openCheckout = function openCheckout() {
    trackRequestToBookAction();
    trackRequestIntentionAction();
    trackRequestToBookAmplitudeAction(isAnyTypeFixed ? selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.start_date : moveInRequest, isAnyTypeFixed ? selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.end_date : moveOutRequest, guests, optionId, offerId, fromMoneyCoreFormat(firstRentValue === null || firstRentValue === void 0 ? void 0 : firstRentValue.amount) || fromMoneyCoreFormat(referencePrice.amount), (firstRentValue === null || firstRentValue === void 0 ? void 0 : firstRentValue.currency_code) || referencePrice.currency_code, getAvailableFrom(accommodationOffer), propertyType, offerType, router.query.city, getCountryNamefromCityCode(cityCode), offerGenderRestriction, propertyGenderRestriction);
    redirectToCheckout(offerId, isAnyTypeFixed ? {
      guests: guests,
      optionId: optionId
    } : {
      guests: guests,
      moveIn: moveInDate,
      moveOut: moveOutDate
    }, language);
  };
  var openCheckoutOrDoubleBookingModal = function openCheckoutOrDoubleBookingModal() {
    if (isDoubleBooking(paidBookings, moveIn, moveOut)) {
      showDoubleBookingModal({
        onRequestBookingAnyway: openCheckout
      });
      return;
    }
    openCheckout();
  };
  var setGuests = function setGuests(updatedGuests) {
    if (+updatedGuests === priceDetailsRequest.guests) {
      return;
    }
    setPriceDetailsRequest({
      guests: +updatedGuests
    });
  };
  var onConfirm = useCallback(function (moveIn, moveOut, guests, optionId) {
    setIsCalendarOpen(false);
    if (isAnyTypeFixed) {
      trackFixedContractConfirmClickAction(offerId);
    }
    changeUrlQuery(router, {
      'move-in': moveIn,
      'move-out': moveOut,
      guests: guests,
      optionId: optionId
    });
  }, [moveIn, moveOut, guests, optionId]);
  var formattedFirstRentValue = firstRentValue && formatMoney(firstRentValue.amount, firstRentValue.currency_code);
  var formattedReferencePrice = formatMoney(referencePrice.amount, referencePrice.currency_code);
  var onConfirmSuggested = function onConfirmSuggested(moveInSuggested, moveOutSuggested) {
    changeUrlQuery(router, {
      moveIn: moveInSuggested,
      moveOut: moveOutSuggested,
      guests: guests,
      optionId: optionId
    });
  };
  var _useState2 = useState(!isAnyTypeFixed && isRangeValid(moveIn && formatDate(moveInDate), moveOut && formatDate(moveOutDate), t, language, accommodationOffer)),
    validations = _useState2[0],
    setValidations = _useState2[1];
  useEffect(function () {
    setValidations(!isAnyTypeFixed && isRangeValid(moveIn && formatDate(moveInDate), moveOut && formatDate(moveOutDate), t, language, accommodationOffer));
  }, [moveIn, moveOut, priceDetailsRequest, language]);
  var fixedContractOptions = (contract === null || contract === void 0 ? void 0 : (_contract$fixed = contract.fixed) === null || _contract$fixed === void 0 ? void 0 : _contract$fixed.options) || (contract === null || contract === void 0 ? void 0 : (_contract$fixed_unita = contract.fixed_unitary) === null || _contract$fixed_unita === void 0 ? void 0 : _contract$fixed_unita.options);
  var selectedOption = fixedContractOptions === null || fixedContractOptions === void 0 ? void 0 : fixedContractOptions.find(function (option) {
    return option.id === optionId;
  });
  var formattedStartDate = selectedOption !== null && selectedOption !== void 0 && selectedOption.start_date ? formatDate(new Date(selectedOption.start_date), language, DATE_FORMAT) : null;
  var formattedEndDate = selectedOption !== null && selectedOption !== void 0 && selectedOption.end_date ? formatDate(new Date(selectedOption.end_date), language, DATE_FORMAT) : null;
  useEffect(function () {
    var _normalizeQuery = normalizeQuery(router.query),
      moveIn = _normalizeQuery.moveIn,
      moveOut = _normalizeQuery.moveOut,
      guests = _normalizeQuery.guests,
      optionId = _normalizeQuery.optionId;
    var shouldRequestPriceDetails = false;
    if (moveIn && moveIn !== priceDetailsRequest.moveIn && moveOut && moveOut !== priceDetailsRequest.moveOut) {
      setMoveInOut(moveIn, moveOut);
      shouldRequestPriceDetails = true;
    }
    if (+guests && +guests !== priceDetailsRequest.guests) {
      setPriceDetailsRequest({
        guests: +guests
      });
      shouldRequestPriceDetails = true;
    }
    if (optionId && optionId !== priceDetailsRequest.optionId) {
      selectFixedOption(optionId);
      shouldRequestPriceDetails = true;
    }
    if (shouldRequestPriceDetails) {
      requestPriceDetails();
    }
  }, [router.query]);
  useEffect(function () {
    if (isCalendarOpen) {
      lockScroll(HEADER_SIZE);
    }
    return function () {
      return unlockScroll();
    };
  }, [isCalendarOpen]);
  return __jsx(MainWrapper, {
    id: "pricing-box"
  }, !isCalendarOpen && __jsx(Notifications, {
    validations: validations,
    extraData: {
      extraPrice: extraPrice,
      isInstantBooking: isInstantBooking,
      setMoveInOut: onConfirmSuggested
    }
  }), __jsx(Wrapper, null, __jsx(Content, null, __jsx(LeftSection, null, __jsx(Price, {
    isClickable: hasPriceDetails,
    onClick: hasPriceDetails ? openPaymentDetails : null
  }, formattedFirstRentValue || formattedReferencePrice, __jsx("span", null, "/".concat(t('month')))), __jsx(Dates, {
    hasDates: moveIn && moveOut
  }, moveIn && moveOut || optionId ? __jsx(React.Fragment, null, __jsx("span", null, isAnyTypeFixed ? formattedStartDate : formattedMoveIn), " -", ' ', __jsx("span", null, isAnyTypeFixed ? formattedEndDate : formattedMoveOut)) : __jsx("span", null, t('Add dates for price')))), __jsx(Button, {
    isPrimary: true,
    isDisabled: isLoading,
    onClick: (moveIn && moveOut || optionId) && hasPriceDetails ? openCheckoutOrDoubleBookingModal : openCalendar
  }, (moveIn && moveOut || optionId) && hasPriceDetails ? t('Reserve') : t('Select dates'))), isCalendarOpen && __jsx(Calendar, {
    onClose: closeCalendar,
    accommodationOffer: accommodationOffer,
    property: property,
    priceDetailsRequest: priceDetailsRequest,
    priceDetailsData: priceDetailsData,
    setMoveInOut: setMoveInOut,
    setGuests: setGuests,
    selectFixedOption: selectFixedOption,
    extraPrice: extraPrice,
    onConfirm: showPaymentSummary ? openCheckout : onConfirm,
    isLoading: isLoading,
    showPaymentSummary: showPaymentSummary && Object.keys(priceDetailsData).length,
    setShowPaymentSummary: setShowPaymentSummary
  })));
};
var mapStateToProps = function mapStateToProps(_ref5) {
  var paidBookings = _ref5.profile.paidBookings,
    _ref5$offer = _ref5.offer,
    _ref5$offer$priceDeta = _ref5$offer.priceDetails,
    isLoading = _ref5$offer$priceDeta.isLoading,
    priceDetailsRequest = _ref5$offer$priceDeta.request,
    priceDetailsData = _ref5$offer$priceDeta.data,
    offerAggregate = _ref5$offer.offerAggregate,
    isCalendarOpen = _ref5$offer.isCalendarOpen;
  return {
    paidBookings: paidBookings,
    priceDetailsRequest: priceDetailsRequest || {},
    priceDetailsData: priceDetailsData || {},
    hasPriceDetails: !!priceDetailsData,
    accommodationOffer: offerAggregate.accommodation_offer,
    isLoading: isLoading,
    isCalendarOpen: isCalendarOpen,
    property: offerAggregate.property_aggregate.property
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setPriceDetailsRequest: function setPriceDetailsRequest(_ref6) {
      var guests = _ref6.guests,
        moveIn = _ref6.moveIn,
        moveOut = _ref6.moveOut,
        optionId = _ref6.optionId;
      return dispatch(_setPriceDetailsRequest({
        guests: guests,
        moveIn: moveIn,
        moveOut: moveOut,
        optionId: optionId
      }));
    },
    setIsCalendarOpen: function setIsCalendarOpen(newValue) {
      return dispatch(setIsCalendarOpenAction({
        isCalendarOpen: newValue
      }));
    },
    showDoubleBookingModal: function showDoubleBookingModal(_ref7) {
      var onRequestBookingAnyway = _ref7.onRequestBookingAnyway;
      return dispatch(showModalAction({
        modalId: modalIds.DOUBLE_BOOKING,
        onRequestBookingAnyway: onRequestBookingAnyway
      }));
    },
    requestPriceDetails: function requestPriceDetails() {
      return dispatch(_requestPriceDetails());
    },
    clearPriceDetails: function clearPriceDetails() {
      return dispatch(setPriceDetailsData({
        priceDetails: null
      }));
    },
    trackSelectDatesAction: function trackSelectDatesAction() {
      return dispatch(trackSelectDates());
    },
    trackRequestToBookAction: function trackRequestToBookAction() {
      return dispatch(trackRequestToBook());
    },
    trackRequestIntentionAction: function trackRequestIntentionAction() {
      return dispatch(trackRequestIntention());
    },
    trackFixedContractModalOpenAction: function trackFixedContractModalOpenAction(offerId) {
      return dispatch(trackFixedContractModalOpen({
        offerId: offerId
      }));
    },
    trackFixedContractOptionClickAction: function trackFixedContractOptionClickAction(offerId) {
      return dispatch(trackFixedContractOptionClick({
        offerId: offerId
      }));
    },
    trackFixedContractConfirmClickAction: function trackFixedContractConfirmClickAction(offerId) {
      return dispatch(trackFixedContractConfirmClick({
        offerId: offerId
      }));
    },
    trackFixedContractCancelClickAction: function trackFixedContractCancelClickAction(offerId) {
      return dispatch(trackFixedContractCancelClick({
        offerId: offerId
      }));
    },
    trackRequestToBookAmplitudeAction: function trackRequestToBookAmplitudeAction(moveIn, moveOut, guests, optionId, offerId, price, currencyCode, availableFrom, propertyType, offerType, city, country, offerGenderRestriction, propertyGenderRestriction) {
      return dispatch(trackRequestToBookAmplitude({
        moveIn: moveIn,
        moveOut: moveOut,
        guests: guests,
        optionId: optionId,
        offerId: offerId,
        price: price,
        currencyCode: currencyCode,
        availableFrom: availableFrom,
        propertyType: propertyType,
        offerType: offerType,
        city: city,
        country: country,
        offerGenderRestriction: offerGenderRestriction,
        propertyGenderRestriction: propertyGenderRestriction
      }));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(PricingBoxMobile);